<template>
    <div>
       <HeaderTeam header="ลงเวลาการทำงาน" :img_header="header_image" link_back="team"/>
       <MenuTeamAddTimeWorkList/>
       <InTimeWorkList/>
    </div>
</template>

<script>
import HeaderImage from '@/assets/stopwatch.png'
import HeaderTeam from '@/components/menuadmin/team/teamheader/HeaderTeam.vue'
import MenuTeamAddTimeWorkList from '@/components/menuadmin/team/teamaddtimework/MenuTeamAddTimeWorkList.vue'
import InTimeWorkList from '@/components/menuadmin/team/teamaddtimework/InTimeWorkList.vue'
export default {
    name:'inTimeWork',
    components:{
        HeaderTeam,
        MenuTeamAddTimeWorkList,
        InTimeWorkList,
    },
    data(){
        return{
            header_image:HeaderImage
        }
    }
}
</script>